import { BuilderConfig } from '@/types/builder';

import RoomStayCalculator, { CalculatorProps } from './roomstay-calculator';

export const RoomStayCalculatorBuilderConfig = {
    name: 'Calculator',
    inputs: [
        {
            name: 'title',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'subTitle',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'highlightText',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'subDescription',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'ctaButton',
            type: 'object',
            subFields: [
                {
                    name: 'text',
                    type: 'string',
                    defaultValue: '',
                },
                {
                    name: 'href',
                    type: 'string',
                    defaultValue: '',
                },
            ],
        }
    ],
};

const builderConfig: BuilderConfig<CalculatorProps> = {
    component: RoomStayCalculator,
    config: RoomStayCalculatorBuilderConfig,
};

export default builderConfig;
